import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/123.png'


const _withScopeId = n => (_pushScopeId("data-v-6c67f9c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"product-detail\" data-v-6c67f9c2><div class=\"product-til\" data-v-6c67f9c2>产品参数</div><div data-v-6c67f9c2><b data-v-6c67f9c2>交付形式 ：</b><i class=\"iconfont icon-gou\" data-v-6c67f9c2></i><p data-v-6c67f9c2>人工交付</p></div><div data-v-6c67f9c2><b data-v-6c67f9c2>交付时间 ：</b><i class=\"iconfont icon-gou\" data-v-6c67f9c2></i><p data-v-6c67f9c2>线下商议</p></div><div data-v-6c67f9c2><b data-v-6c67f9c2>使用场景 ：</b><i class=\"iconfont icon-gou\" data-v-6c67f9c2></i><p data-v-6c67f9c2>低峰期多门口需安排员工迎客，则工作不饱和；投资与产出比不合理。</p></div></div>", 1)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-til" }, "产品亮点", -1))
const _hoisted_5 = { class: "highlights" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "智能识别", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "实时视频", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "推送消息", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "highlights-text" }, " 智能迎客为了解决店门口未安排人员接待时容易出现迎客不及时，导致顾客体验感觉不够好。所以需要一款携带方便的视觉分析应用，轻巧且操作简单的智能手环；与其它终端设备相比，具有成本低廉，续航能力等优势。 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "product-til" }, "应用案例"),
  /*#__PURE__*/_createElementVNode("div", { class: "case" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "摄像头+AI算法识别门口顾客，并将有效顾客信息推送至手环应用。")
    ])
  ])
], -1))

import { comDialog } from '@/utils'
import ComHeader from '@/components/ComHeader/index.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "产品介绍"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_router_link, {
          tag: "i",
          to: "/shop",
          class: "iconfont icon-dianpu"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "banner",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(comDialog)('已申请试用，会有专员致电')))
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/product.png')
      }, null, 8, _hoisted_2)
    ]),
    _hoisted_3,
    _createElementVNode("div", null, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/icon@3x(3).png'),
            alt: ""
          }, null, 8, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/icon@3x(4).png'),
            alt: ""
          }, null, 8, _hoisted_8),
          _hoisted_9
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/icon@3x(5).png'),
            alt: ""
          }, null, 8, _hoisted_10),
          _hoisted_11
        ])
      ]),
      _hoisted_12
    ]),
    _hoisted_13
  ]))
}
}

})